import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Col, Row, Table, Image, Modal, Button, Form } from "react-bootstrap";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  FormControl,
  Select,
  IconButton,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Scrollbars from "react-custom-scrollbars";
import { ReusableOnboardingButton } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";
import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import DrogDropItem from "../../SeatingManagement/DrogDropItem";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { admin_update_new_subscription_for_vendor } from "../../../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import { useHistory } from "react-router";

// Helper functions
function move(array, oldIndex, newIndex) {
  if (newIndex >= array.length) {
    newIndex = array.length - 1;
  }
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
  return array;
}

function moveElement(array, index, offset) {
  const newIndex = index + offset;

  return move(array, index, newIndex);
}

// Context

export const CateringRoomSeatManagement = (props) => {
  //state
  const history = useHistory();
  const [activetabs, setActiveTabs] = useState(1);
  const handleTablesSeats = (v) => {
    setActiveTabs(v);
    setShowGridList(false);
  };

  const goPreviousPage = () => {
    history.push("/admin-casual-dining/ordering/cateringbanquet/room");
  };
  const [state, setState] = useState({
    floor: "1",
    section: "1",
    tableShape: "",
    tableStatus: "available",
    tableCapacity: "",
    seatCapacity: "1",
    items: [
      {
        id: "1",
        location: "Outdoor",
        seatNo: "A1",
        tableNo: "A-101",
        status: "available",
        src: require("../../../../../../../assets/images/tablemanagement/table/1-circle-available.svg"),
      },
      {
        id: "2",
        location: "Garden",
        seatNo: "A2",
        tableNo: "A-102",
        status: "dirty",
        src: require("../../../../../../../assets/images/tablemanagement/table/2-circle-onhold.svg"),
      },
      {
        id: "3",
        location: "Patio",
        seatNo: "A3",
        tableNo: "A-103",
        status: "occupied",
        src: require("../../../../../../../assets/images/tablemanagement/table/3-circle-unavailable.svg"),
      },
      {
        id: "4",
        location: "Patio",
        seatNo: "A4",
        tableNo: "A-104",
        status: "onhold",
        src: require("../../../../../../../assets/images/tablemanagement/table/4-square-occupied.svg"),
      },
      {
        id: "5",
        location: "Patio",
        seatNo: "A5",
        tableNo: "A-105",
        status: "unavailable",
        src: require("../../../../../../../assets/images/tablemanagement/table/12-rectangle-dirty.svg"),
      },
    ],
  });

  const selecthandleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const [showCreateRoom, setShowCreateRoom] = useState(false);
  const [showCreateBanquet, setShowCreateBanquet] = useState(false);
  const [showGridList, setShowGridList] = useState(false);
  const handleCreateRoom = () => setShowCreateRoom(true);
  const handleCloseCreateRoom = () => {
    setEditRoom(false);
    setRoomUniqueId("");
    setShowCreateRoom(false);
    formikRoom.resetForm();
  };
  const handleCreateBanquet = () => setShowCreateBanquet(true);
  const handleCloseCreateBanquet = () => {
    setEditBanquet(false);
    setBanquetUniqueId("");
    setShowCreateBanquet(false);
    formikBanquet.resetForm();
  };
  const handleGridList = () => {
    setShowGridList({
      showGridList: !showGridList.showGridList,
    });
  };

  //move function
  const setItems = (items) => setState({ ...state, items });

  const moveItem = (sourceId, destinationId) => {
    const sourceIndex = state.items.findIndex((item) => item.id === sourceId);
    const destinationIndex = state.items.findIndex(
      (item) => item.id === destinationId
    );

    // If source/destination is unknown, do nothing.
    if (sourceId === -1 || destinationId === -1) {
      return;
    }

    const offset = destinationIndex - sourceIndex;

    setState((state) => ({
      ...state,
      items: moveElement(state.items, sourceIndex, offset),
    }));
  };

  const showAlert = (msg) => {
    Alert.success(`<h4>${msg}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const tableShape = [
    // { name: "Circle", totalPax: [1, 2, 3, 4] },
    // { name: "Square", totalPax: [1, 2, 3, 4] },
    { name: "Rectangle", totalPax: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
  ];

  //delete table

  const [deleteRoom, setDeleteRoom] = useState(false);

  // delete seat

  const [deleteBanquet, setDeleteBanquet] = useState(false);

  const handleCloseDeleteRoom = () => {
    setDeleteRoom(false);
  };

  const handleCloseDeleteBanquet = () => {
    setDeleteBanquet(false);
  };
  const onClickYesDeleteRoom = () => {
    //    allDashboardRoomData
    let tempData = filteredRoomDataDashboard;
    let actualTemp = allDashboardRoomData;

    let filterActualTable = actualTemp.filter((table) => {
      return table.uniqueId !== roomUniqueId;
    });

    let filteredTable = tempData.filter((table) => {
      return table.uniqueId !== roomUniqueId;
    });
    setAllDashboardRoomData(filterActualTable);
    setFilteredRoomDataDashboard(filteredTable);
    setRoomUniqueId("");
    showAlert("Room Deleted Sucessfully");
    handleCloseDeleteRoom();
  };

  const onClickYesDeleteBanquet = () => {
    //    allDashboardRoomData
    let tempData = filteredBanquetDataDashboard;
    let actualTemp = allDashboardBanquetData;

    let filterActualSeat = actualTemp.filter((seat) => {
      return seat.uniqueId !== banquetUniqueId;
    });

    let filteredSeat = tempData.filter((seat) => {
      return seat.uniqueId !== banquetUniqueId;
    });
    setAllDashboardBanquetData(filterActualSeat);
    setFilteredBanquetDataDashboard(filteredSeat);
    setBanquetUniqueId("");
    showAlert("Banquet Deleted Sucessfully");
    handleCloseDeleteBanquet();
  };

  const onClickDeleteTableIcon = (id) => {
    setRoomUniqueId(id);
    setDeleteRoom(true);
  };

  const onClickDeleteBanquetIcon = (id) => {
    setBanquetUniqueId(id);
    setDeleteBanquet(true);
  };

  const [editRoom, setEditRoom] = useState(false);
  const [editBanquet, setEditBanquet] = useState(false);
  const [roomUniqueId, setRoomUniqueId] = useState("");
  const [banquetUniqueId, setBanquetUniqueId] = useState("");
  const onClickEditTable = (tableData) => {
    let e = {};
    e.target = {};
    e.target.value = tableData.floor_number;
    onChangeFloorNumber(e);
    setRoomUniqueId(tableData.uniqueId);
    setEditRoom(true);
    handleCreateRoom();
    formikRoom.setValues(tableData);
  };

  const onClickEditBanquet = (seatData) => {
    let e = {};
    e.target = {};
    e.target.value = seatData.floor_number;
    onChangeSeatNumber(e);
    setBanquetUniqueId(seatData.uniqueId);
    setEditBanquet(true);
    handleCreateBanquet();
    formikBanquet.setValues(seatData);
  };

  const [activeTableShape, setActiveTableShape] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
  ]);

  const onChangeRoomShape = (e) => {
    let tableShpe = e.target.value;
    formikRoom.setFieldValue("room_shape", tableShpe);
    formikRoom.setFieldValue("pax", "");
    for (let i = 0; i < tableShape.length; i++) {
      if (tableShpe === tableShape[i].name) {
        setActiveTableShape(tableShape[i].totalPax);
        break;
      }
    }
  };

  const onChangeSelectRoomLocation = (name) => {
    formikRoom.setFieldValue("roomLocation", name);
  };

  const onChangeSelectSeat = (name) => {
    formikBanquet.setFieldValue("location", name);
  };

  const [tableLocation, setTableLocation] = useState([]);

  // for table
  const [activeFloorRoomDashboard, setActiveFloorRoomDashboard] = useState("");
  const [activeAreaRoomDashboard, setActiveAreaRoomDashboard] = useState("");

  // for seat

  const [activeFloorBanquetDashboard, setActiveFloorBanquetDashboard] =
    useState("");
  const [activeAreaBanquetDashboard, setActiveAreaBanquetDashboard] =
    useState("");

  const onChangeDashboardRoomFloorNumber = (e) => {
    let floorNo = e.target.value;
    setActiveFloorRoomDashboard(floorNo);
    //let activeData=[]
    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
  };

  const onChangeDashboardBanquetFloorNumber = (e) => {
    let floorNo = e.target.value;
    setActiveFloorBanquetDashboard(floorNo);

    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
  };

  const onChangeDashboardRoomArea = (e) => {
    let areaNo = e.target.value;
    let filterData = [];
    setActiveAreaRoomDashboard(areaNo);

    for (let i = 0; i < allDashboardRoomData.length; i++) {
      if (
        allDashboardRoomData[i].floor_number === activeFloorRoomDashboard &&
        allDashboardRoomData[i].room_number === areaNo
      ) {
        filterData.push(allDashboardRoomData[i]);
      }
    }
    setFilteredRoomDataDashboard(filterData);
  };

  const onChangeDashboardBanquetArea = (e) => {
    let areaNo = e.target.value;
    let filterData = [];
    setActiveAreaBanquetDashboard(areaNo);

    for (let i = 0; i < allDashboardBanquetData.length; i++) {
      if (
        allDashboardBanquetData[i].floor_number ===
          activeFloorBanquetDashboard &&
        allDashboardBanquetData[i].area === areaNo
      ) {
        filterData.push(allDashboardBanquetData[i]);
      }
    }
    setFilteredBanquetDataDashboard(filterData);
  };

  const [allDashboardRoomData, setAllDashboardRoomData] = useState([]);

  const [allDashboardBanquetData, setAllDashboardBanquetData] = useState([]);

  const [filteredRoomDataDashboard, setFilteredRoomDataDashboard] = useState(
    []
  );

  const [filteredBanquetDataDashboard, setFilteredBanquetDataDashboard] =
    useState([]);

  const [uniqueFloorData, setUniqueFloorData] = useState([]);
  const [activeSectionData, setActiveSectionData] = useState([]);
  const onChangeFloorNumber = (e) => {
    let floorNo = e.target.value;
    //let activeData=[]
    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
    formikRoom.setFieldValue("floor_number", floorNo);
    formikRoom.setFieldValue("area", "");
  };

  const onChangeSeatNumber = (e) => {
    let floorNo = e.target.value;
    //let activeData=[]
    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
    formikBanquet.setFieldValue("floor_number", floorNo);
    formikBanquet.setFieldValue("area", "");
  };

  const onChangeRoomNumber = (e) => {
    formikRoom.setFieldValue("room_number", e.target.value);
  };

  const onChangeSeatArea = (e) => {
    formikBanquet.setFieldValue("area", e.target.value);
  };
  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };
  //const [selectedTable, setSelectedTable] = useState("");

  const onChangeTableTemporary = () => {
    formikRoom.setFieldValue("temporay", !formikRoom.values.temporay);
  };

  const onChangeSeatTemporary = () => {
    formikBanquet.setFieldValue("temporay", !formikBanquet.values.temporay);
  };
  const onChangeTableActiveInActive = () => {
    if (!formikRoom.values.active === false) {
      formikRoom.setFieldValue("room_status", "Unavailable");
      formikRoom.setFieldValue("active", !formikRoom.values.active);
    } else {
      formikRoom.setFieldValue("active", !formikRoom.values.active);
      formikRoom.setFieldValue("room_status", "Available");
    }
  };

  const onChangeSeatActiveInActive = () => {
    if (!formikBanquet.values.active === false) {
      formikBanquet.setFieldValue("status", "false");
      formikBanquet.setFieldValue("active", !formikBanquet.values.active);
    } else {
      formikBanquet.setFieldValue("active", !formikBanquet.values.active);
      formikBanquet.setFieldValue("status", "true");
    }
  };

  const onCLickAddNewRoom = () => {
    formikRoom.handleSubmit();
  };

  const formikRoom = useFormik({
    initialValues: {
      floor_number: "",
      room_number: "",
      room_type: "",
      room_shape: "Rectangle",
      pax: "4",
      temporay: false,
      active: true,
      roomLocation: "",
      room_status: "Available",
      area: "",
    },
    validationSchema: yup.object({
      floor_number: yup.string().required("Please select floor number "),
      room_number: yup.string().required("Please select room number "),
      room_type: yup.string().required("Please enter room type"),
      pax: yup.string().required("Please select total capacity"),
      //roomLocation: yup.string().required("Please select room location "),
      area: yup.string().required("Please enter numer of rooms to create "),
    }),

    onSubmit: (values) => {
      if (!editRoom) {
        // for new data
        let room = [];
        let existingTableData = allDashboardRoomData;

        for (let i = 0; i < values.area; i++) {
          let increment_number = i + 1;
          let incrementTableNumber =
            values.room_number + "-" + increment_number;
          let generateUniqueId = allDashboardRoomData.length + increment_number;
          room.push({
            ...values,
            area: incrementTableNumber,
            uniqueId: generateUniqueId,
          });
        }
        let formData = [...existingTableData, ...room];
        setAllDashboardRoomData(formData);
        setFilteredRoomDataDashboard(formData);
      } else {
        let filteredData = filteredRoomDataDashboard;
        let actualAllTableData = allDashboardRoomData;
        let updatedFilteredData = [];
        let updatedActualData = [];

        // this loop is for setting data for what we see on filtered screen
        for (let i = 0; i < filteredData.length; i++) {
          if (
            filteredData[i].uniqueId === roomUniqueId &&
            filteredData[i].floor_number === values.floor_number &&
            filteredData[i].area === values.area
          ) {
            updatedFilteredData.push(values);
          } else if (filteredData[i].uniqueId === roomUniqueId) {
            // dont append as user changed floor / area
          } else {
            updatedFilteredData.push(filteredData[i]);
          }
        }
        for (let i = 0; i < actualAllTableData.length; i++) {
          if (actualAllTableData[i].uniqueId === roomUniqueId) {
            updatedActualData.push(values);
          } else {
            updatedActualData.push(actualAllTableData[i]);
          }
        }
        if (activeFloorRoomDashboard === "" && activeAreaRoomDashboard === "") {
          setFilteredRoomDataDashboard(updatedActualData);
        } else {
          setFilteredRoomDataDashboard(updatedFilteredData);
        }
        setAllDashboardRoomData(updatedActualData);
        setRoomUniqueId("");
        showAlert("Room Edited Sucessfully");
      }

      handleCloseCreateRoom();
      formikRoom.resetForm();
    },
  });

  const onCLickAddNewSeat = () => {
    formikBanquet.handleSubmit();
  };

  const formikBanquet = useFormik({
    initialValues: {
      floor_number: "",
      area: "",
      //banquet_number: "",
      banquet_name: "",
      capacity: "",
      shape: "Rounded Square",
      temporary: false,
      active: true,
      location: "",
      status: true,
    },
    validationSchema: yup.object({
      floor_number: yup.string().required("Please select floor number "),
      area: yup.string().required("Please select area/section "),
      banquet_name: yup.string().required("Please enter banquet name"),
      capacity: yup.string().required("Please enter total capacity"),
      // location: yup.string().required("Please select seat location "),
    }),

    onSubmit: (values) => {
      if (!editBanquet) {
        // for new data
        let banquetData = [];
        let existingTableData = allDashboardBanquetData;

        let generateUniqueId = allDashboardBanquetData.length + 1;
        banquetData.push({
          ...values,
          uniqueId: generateUniqueId,
        });

        let formData = [...existingTableData, ...banquetData];
        setAllDashboardBanquetData(formData);
        setFilteredBanquetDataDashboard(formData);
      } else {
        let filteredData = filteredBanquetDataDashboard;
        let actualAllSeatData = allDashboardBanquetData;
        let updatedFilteredData = [];
        let updatedActualData = [];

        // this loop is for setting data for what we see on filtered screen
        for (let i = 0; i < filteredData.length; i++) {
          if (
            filteredData[i].uniqueId === banquetUniqueId &&
            filteredData[i].floor_number === values.floor_number &&
            filteredData[i].area === values.area
          ) {
            updatedFilteredData.push(values);
          } else if (filteredData[i].uniqueId === banquetUniqueId) {
            // dont append as user changed floor / area
          } else {
            updatedFilteredData.push(filteredData[i]);
          }
        }
        for (let i = 0; i < actualAllSeatData.length; i++) {
          if (actualAllSeatData[i].uniqueId === banquetUniqueId) {
            updatedActualData.push(values);
          } else {
            updatedActualData.push(actualAllSeatData[i]);
          }
        }
        if (
          activeFloorBanquetDashboard === "" &&
          activeAreaBanquetDashboard === ""
        ) {
          setFilteredBanquetDataDashboard(updatedActualData);
        } else {
          setFilteredBanquetDataDashboard(updatedFilteredData);
        }
        setAllDashboardBanquetData(updatedActualData);
        setBanquetUniqueId("");
        showAlert("Banquet Edited Sucessfully");
      }

      handleCloseCreateBanquet();
      formikBanquet.resetForm();
    },
  });

  const onClickDone = () => {
    if (
      allDashboardRoomData.length === 0 &&
      allDashboardBanquetData.length === 0
    ) {
      Alert.error(`<h4>Please  setup atleast one room or banquet</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const formData = props.allSubscriptionData;

      formData.casual_dining_status.ordering.catering_banquet.banquet_area.standard = true;
      formData.casual_dining_status.ordering.catering_banquet.banquet_area.general_rooms =
        allDashboardRoomData;
      formData.casual_dining_status.ordering.catering_banquet.banquet_area.banquet =
        allDashboardBanquetData;
      //formData.casual_dining_status.seating.table_management.table_setup = values;

      const token = props.auth.user.accessToken;
      const subscriptionId = props?.subscription?._id;
      props.admin_update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    }
  };

  // data for banquet and room

  const [showCreateSeat, setShowCreateSeat] = useState(false);

  const handleCloseCreateSeat = () => {
    setShowCreateSeat(false);
  };

  const handleCreateSeat = () => {
    setShowCreateSeat(true);
  };

  const onSuccess = (e) => {
    Alert.success(`<h4>Room / Banquet setup Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/admin-casual-dining/ordering");
  };

  useEffect(() => {
    let data = props.allSubscriptionData;

    if (
      data &&
      data.casual_dining_status &&
      data.casual_dining_status.ordering &&
      data.casual_dining_status.ordering.catering_banquet
      //&& data.casual_dining_status.ordering.catering_banquet.banquet_area
    ) {
      let setDropDownDataForTable =
        data.casual_dining_status.ordering.catering_banquet.banquet_area.floors;
      // set unique id to each recond locally

      // for table starts
      let asiignIdToEachRecord = []; // help us to delete or edit record

      let apiTableData =
        data.casual_dining_status.ordering.catering_banquet.banquet_area
          .general_rooms;

      for (let i = 0; i < apiTableData.length; i++) {
        let incrementId = i + 1;
        let data = apiTableData[i];
        data.uniqueId = incrementId;
        asiignIdToEachRecord.push(data);
      }

      setAllDashboardRoomData(asiignIdToEachRecord); // this is our main reference
      setFilteredRoomDataDashboard(asiignIdToEachRecord);

      //// for table ends

      // for seat starts
      let asiignIdToEachRecordSeat = []; // help us to delete or edit record

      let apiSeatData =
        data.casual_dining_status.ordering.catering_banquet.banquet_area
          .banquet;

      for (let i = 0; i < apiSeatData.length; i++) {
        let incrementId = i + 1;
        let data = apiSeatData[i];
        data.uniqueId = incrementId;
        asiignIdToEachRecordSeat.push(data);
      }

      setAllDashboardBanquetData(asiignIdToEachRecordSeat); // this is our main reference
      setFilteredBanquetDataDashboard(asiignIdToEachRecordSeat);

      //// for seat ends

      //
      let uniqueFloors = [];
      for (let i = 0; i < setDropDownDataForTable.length; i++) {
        if (!uniqueFloors.includes(setDropDownDataForTable[i].floor_number)) {
          uniqueFloors.push(setDropDownDataForTable[i].floor_number);
        }
      }

      let structuredData = [];
      for (let i = 0; i < uniqueFloors.length; i++) {
        structuredData.push({ name: uniqueFloors[i], items: [] });
      }
      let finalStructuredData = structuredData;
      for (let i = 0; i < setDropDownDataForTable.length; i++) {
        for (let j = 0; j < structuredData.length; j++) {
          if (
            structuredData[j].name === setDropDownDataForTable[i].floor_number
          ) {
            finalStructuredData[j].items.push(setDropDownDataForTable[i].area);
          }
        }
      }

      setUniqueFloorData(finalStructuredData);
      let selectedSeating =
        data.casual_dining_status.seating.general_seating.seating_areas;
      let seatingSelected = [];

      for (let i = 0; i < props.seating_area.length; i++) {
        if (selectedSeating.includes(props.seating_area[i]._id)) {
          seatingSelected.push(props.seating_area[i]);
        }
      }
      setTableLocation(seatingSelected);
    }
  }, [props.allSubscriptionData, props.seating_area]);
  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <div
                  className="col-12 new-subscription-onboarding-component"
                  style={{ backgroundColor: "#FFFFFF" }}
                >
                  {/* <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={
                      "/admin-casual-dining/ordering/cateringbanquet/room"
                    }
                  />
                </div> */}

                  <div className="col-8 onboarding_process_screen-button-map">
                    <div className="pb-4">
                      <TopTextReusableComponent headingText="Room /Banquet Area Management" />
                    </div>
                    <div className="d-flex align-items-center pb-5">
                      <button
                        type="button"
                        className={`enTabsBtn ${
                          activetabs === 1 ? "active" : ""
                        }`}
                        onClick={() => handleTablesSeats(1)}
                      >
                        Create Room
                      </button>
                      <button
                        type="button"
                        className={`enTabsBtn ${
                          activetabs === 2 ? "active" : ""
                        }`}
                        onClick={() => handleTablesSeats(2)}
                      >
                        Create Banquet
                      </button>
                    </div>
                    {activetabs === 1 && (
                      <React.Fragment>
                        <Row>
                          <Col md={5}>
                            <FormControl variant="outlined" className={"w-100"}>
                              <Select
                                value={activeFloorRoomDashboard}
                                onChange={onChangeDashboardRoomFloorNumber}
                                inputProps={{
                                  name: "floor",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {uniqueFloorData.map((item, index) => (
                                  <MenuItem key={index} value={item.name}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <div className="f10-400 opacity5">
                              (Select Floor from Above)
                            </div>
                          </Col>
                          <Col md={3}>
                            <FormControl variant="outlined" className={"w-100"}>
                              <Select
                                value={activeAreaRoomDashboard}
                                onChange={onChangeDashboardRoomArea}
                                inputProps={{
                                  name: "section",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {activeSectionData.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <div className="f10-400 opacity5">
                              (Select Section on this Floor)
                            </div>
                          </Col>
                        </Row>
                        <Row className="py-4">
                          <Col md={6}>
                            <div className="f14-500">Room Arrangement</div>
                          </Col>
                          <Col md={6}>
                            <Row className="justify-content-between">
                              <Col>
                                <AddButtonIconComponent
                                  buttonText="Add Rooms"
                                  fontIcon="fa fa-plus"
                                  colorCss="red"
                                  onClick={handleCreateRoom}
                                />
                              </Col>
                              {/* <Col className="d-flex justify-content-end">
                          <button
                            type="button"
                            className={
                              "add-button-icon-reusable add-button-icon-reusable-blue"
                            }
                            onClick={handleGridList}
                          >
                            Grid view
                          </button>
                        </Col> */}
                            </Row>
                          </Col>
                        </Row>
                        {showGridList.showGridList ? (
                          <React.Fragment>
                            <Scrollbars
                              style={{
                                width: "100%",
                                height: 450,
                                border: "1px solid #dee2e6",
                              }}
                            >
                              <div className="p-4">
                                <DndProvider backend={HTML5Backend}>
                                  <DrogDropItem
                                    displayTable={true}
                                    value={state.items}
                                    moveItem={moveItem}
                                  />
                                </DndProvider>
                              </div>
                            </Scrollbars>
                            <div className="f16-500">Drag and Move</div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Scrollbars
                              style={{
                                width: "100%",
                                height: 400,
                                border: "1px solid #dee2e6",
                                borderRadius: 11,
                              }}
                            >
                              <div className="enTableArrangement table-responsive">
                                <Table className="w-100">
                                  <thead>
                                    <tr>
                                      <th className="f12-700">Floor</th>
                                      <th className="f12-700">Room Type</th>
                                      <th className="f12-700">No.</th>
                                      <th className="f12-700">Shape</th>
                                      <th className="f12-700">Capacity</th>
                                      <th className="f12-700">Location</th>
                                      <th className="f12-700">Status</th>
                                      <th className="f12-700">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredRoomDataDashboard.map(
                                      (item, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className="f12-400">
                                              {item.floor_number}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="f12-400">
                                              {item.room_type}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="f12-400">
                                              {item.area}
                                            </div>
                                          </td>
                                          <td>
                                            {item.room_shape === "Square" ? (
                                              <Image
                                                src={require("../../../../../../../assets/images/UserManagement/square.svg")}
                                                alt="square"
                                                title="square"
                                                width="33px"
                                                height="19px"
                                              />
                                            ) : (
                                              <> </>
                                            )}

                                            {item.room_shape === "Rectangle" ? (
                                              <Image
                                                src={require("../../../../../../../assets/images/UserManagement/rectangle.svg")}
                                                alt="Rectangle"
                                                title="Rectangle"
                                                width="33px"
                                                height="19px"
                                              />
                                            ) : (
                                              <> </>
                                            )}

                                            {item.room_shape === "Circle" ? (
                                              <Image
                                                src={require("../../../../../../../assets/images/UserManagement/circle.svg")}
                                                alt="Circle"
                                                title="Circle"
                                                width="33px"
                                                height="19px"
                                              />
                                            ) : (
                                              <> </>
                                            )}
                                          </td>
                                          <td>
                                            <div className="f12-400">
                                              {" "}
                                              {item.pax}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="f12-400">
                                              {item.roomLocation}
                                            </div>
                                          </td>
                                          <td>
                                            <span
                                              className={` ${
                                                item.room_status === "Available"
                                                  ? "enGreenDot"
                                                  : "enYellowDot"
                                              }`}
                                            ></span>
                                          </td>
                                          <td>
                                            <div className="d-flex">
                                              <IconButton className="mr-2 p-0">
                                                <Image
                                                  src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                                  alt="edit table"
                                                  title="edit table"
                                                  className="w-20px"
                                                  onClick={() =>
                                                    onClickEditTable(item)
                                                  }
                                                />
                                              </IconButton>
                                              <IconButton className="p-0">
                                                <Image
                                                  src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                                  alt="delete table"
                                                  title="delete table"
                                                  className="w-20px"
                                                  onClick={() =>
                                                    onClickDeleteTableIcon(
                                                      item.uniqueId
                                                    )
                                                  }
                                                />
                                              </IconButton>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </Scrollbars>
                          </React.Fragment>
                        )}
                        <div className="onboarding-map-setup-screen-autodetect-button pt-5">
                          <ReusableOnboardingButton
                            buttonTitle="Back"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                            buttonText="Back"
                            buttonType="button"
                            onClick={() => goPreviousPage()}
                          />
                          <ReusableOnboardingButton
                            buttonTitle="Done"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                            buttonText="Done"
                            buttonType="button"
                            onClick={() => onClickDone()}
                          />
                        </div>
                      </React.Fragment>
                    )}
                    {activetabs === 2 && (
                      <React.Fragment>
                        <Row>
                          <Col md={5}>
                            <FormControl variant="outlined" className={"w-100"}>
                              <Select
                                value={activeFloorBanquetDashboard}
                                onChange={onChangeDashboardBanquetFloorNumber}
                                inputProps={{
                                  name: "floor",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {uniqueFloorData.map((item, index) => (
                                  <MenuItem key={index} value={item.name}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <div className="f10-400 opacity5">
                              (Select Floor from Above)
                            </div>
                          </Col>
                          <Col md={3}>
                            <FormControl variant="outlined" className={"w-100"}>
                              <Select
                                value={activeAreaBanquetDashboard}
                                onChange={onChangeDashboardBanquetArea}
                                inputProps={{
                                  name: "section",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {activeSectionData.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <div className="f10-400 opacity5">
                              (Select Section on this Floor)
                            </div>
                          </Col>
                        </Row>
                        <Row className="py-4">
                          <Col md={6}>
                            <div className="f14-500">Seat Arrangement</div>
                          </Col>
                          <Col md={6}>
                            <Row className="justify-content-between">
                              <Col>
                                <AddButtonIconComponent
                                  buttonText="Add Banquet"
                                  fontIcon="fa fa-plus"
                                  colorCss="red"
                                  onClick={handleCreateBanquet}
                                />
                              </Col>
                              {/* <Col className="d-flex justify-content-end">
                          <button
                            type="button"
                            className={
                              "add-button-icon-reusable add-button-icon-reusable-blue"
                            }
                            onClick={handleGridList}
                          >
                            Grid view
                          </button>
                        </Col> */}
                            </Row>
                          </Col>
                        </Row>
                        {showGridList.showGridList ? (
                          <React.Fragment>
                            <Scrollbars
                              style={{
                                width: "100%",
                                height: 450,
                                border: "1px solid #dee2e6",
                              }}
                            >
                              {/* <div className="d-flex align-items-center p-2">
                          <div className="enSeat occupied">A1</div>
                          <div className="enSeat available">A2</div>
                          <div className="enSeat dirty">A3</div>
                          <div className="enSeat onhold">A4</div>
                          <div className="enSeat unavailable">A5</div>
                        </div> */}
                              <div className="d-flex align-items-center p-2">
                                <DndProvider backend={HTML5Backend}>
                                  <DrogDropItem
                                    value={state.items}
                                    moveItem={moveItem}
                                  />
                                </DndProvider>
                              </div>
                            </Scrollbars>
                            <div className="f16-500">Drag and Move</div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Scrollbars
                              style={{
                                width: "100%",
                                height: 400,
                                border: "1px solid #dee2e6",
                                borderRadius: 11,
                              }}
                            >
                              <div className="enTableArrangement table-responsive">
                                <Table className="w-100">
                                  <thead>
                                    <tr>
                                      <th className="f12-700">Floor</th>
                                      <th className="f12-700">Area</th>
                                      <th className="f12-700">Banquet</th>
                                      <th className="f12-700">Shape</th>
                                      <th className="f12-700">Capacity</th>
                                      <th className="f12-700">Location</th>
                                      <th className="f12-700">Status</th>
                                      <th className="f12-700">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredBanquetDataDashboard.map(
                                      (item, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className="f12-400">
                                              {item.floor_number}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="f12-400">
                                              {item.area}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="f12-400">
                                              {item.banquet_name}
                                            </div>
                                          </td>
                                          <td>
                                            <Image
                                              src={require("../../../../../../../assets/images/tablemanagement/seat1.svg")}
                                              alt="add"
                                              title="add"
                                              width="33px"
                                              height="33px"
                                            />
                                          </td>
                                          <td>
                                            <div className="f12-400">
                                              {" "}
                                              {item.capacity}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="f12-400">
                                              {" "}
                                              {item.location}
                                            </div>
                                          </td>
                                          <td>
                                            <span
                                              className={` ${
                                                item.status === "Available"
                                                  ? "enGreenDot"
                                                  : "enYellowDot"
                                              }`}
                                            ></span>
                                          </td>
                                          <td>
                                            <div className="d-flex">
                                              <IconButton className="mr-2 p-0">
                                                <Image
                                                  src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                                  alt="edit banquet"
                                                  title="edit banquet"
                                                  className="w-20px"
                                                  onClick={() =>
                                                    onClickEditBanquet(item)
                                                  }
                                                />
                                              </IconButton>
                                              <IconButton className="p-0">
                                                <Image
                                                  src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                                  alt="delete banquet"
                                                  title="delete banquet"
                                                  className="w-20px"
                                                  onClick={() =>
                                                    onClickDeleteBanquetIcon(
                                                      item.uniqueId
                                                    )
                                                  }
                                                />
                                              </IconButton>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </Scrollbars>

                            <Col>
                              <AddButtonIconComponent
                                buttonText="Add Seat in Banquet"
                                fontIcon="fa fa-plus"
                                colorCss="red"
                                onClick={handleCreateSeat}
                              />
                            </Col>
                          </React.Fragment>
                        )}
                        <div className="onboarding-map-setup-screen-autodetect-button pt-5">
                          <ReusableOnboardingButton
                            buttonTitle="Back"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                            buttonText="Back"
                            buttonType="button"
                            onClick={() => goPreviousPage()}
                          />
                          <ReusableOnboardingButton
                            buttonTitle="Done"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                            buttonText="Done"
                            buttonType="button"
                            onClick={() => onClickDone()}
                          />
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal show={showCreateRoom} onHide={handleCloseCreateRoom} centered>
            <Modal.Header className="px-4 border-0" closeButton>
              <div>
                <Modal.Title className="f20-700 pb-2">
                  {editRoom ? "Edit" : "Create"} a Room
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 new-subscription-onboarding-component">
              <Form>
                <Row>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-section">
                        Floor Number /Name
                      </InputLabel>
                      <Select
                        value={formikRoom.values.floor_number}
                        onChange={onChangeFloorNumber}
                        label="Section Number /Name"
                        inputProps={{
                          name: "floor",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {uniqueFloorData.map((item, index) => (
                          <MenuItem key={index} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikRoom.errors.floor_number &&
                      formikRoom.touched.floor_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikRoom.errors.floor_number}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-room">
                        Room Number /Name
                      </InputLabel>
                      <Select
                        value={formikRoom.values.room_number}
                        onChange={onChangeRoomNumber}
                        label="Room Number /Name"
                        inputProps={{
                          name: "room",
                          id: "outlined-room",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {activeSectionData.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikRoom.errors.room_number &&
                      formikRoom.touched.room_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikRoom.errors.room_number}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <NewInputText
                      labelText="Room Type"
                      extraClass={`mb-1 w-100 ${
                        formikRoom.errors.room_type &&
                        formikRoom.touched.room_type
                          ? "enError"
                          : ""
                      }`}
                      inputType="text"
                      name="room_type"
                      onChange={formikRoom.handleChange}
                      value={formikRoom.values.room_type}
                      onFocusOut={formikRoom.handleBlur}
                      // isInvalid={
                      //   formik.errors.bankName && formik.touched.bankName
                      // }
                    />
                    {formikRoom.errors.room_type &&
                    formikRoom.touched.room_type ? (
                      <div className="pho_14_regular text-danger mb-2">
                        {formikRoom.errors.room_type}
                      </div>
                    ) : (
                      <div className="mb-2"></div>
                    )}
                  </Col>
                  {/* <Col md={6}>
                <NewInputText
                  labelText="Table Capacity"
                  extraClass="mb-3 w-100"
                />
                <span className="f14-400 opacity5 enPositionRightTop">pax</span>
              </Col> */}
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-tableShape">
                        Room Shape
                      </InputLabel>
                      <Select
                        value={formikRoom.values.room_shape}
                        //onChange={selecthandleChange}
                        onChange={onChangeRoomShape}
                        name
                        label="Table Shape"
                        inputProps={{
                          name: "shape",
                          id: "outlined-tableShape",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {/* <MenuItem value={"Circle"}>Circle &#9675;</MenuItem> */}
                        <MenuItem value={"Rectangle"}>
                          Rectangle &#9645;
                        </MenuItem>
                        {/* <MenuItem value={"Square"}>Square &#9744;</MenuItem> */}
                      </Select>
                    </FormControl>
                  </Col>
                  <Col md={6} className="mb-3">
                    <FormControl variant="outlined" className={"w-100 mb-0"}>
                      <InputLabel htmlFor="outlined-tableCapacity">
                        Room Capacity
                      </InputLabel>
                      <Select
                        //value={state.tableCapacity}
                        value={formikRoom.values.pax}
                        //onChange={selecthandleChange}
                        onChange={formikRoom.handleChange}
                        label="Table Capacity"
                        inputProps={{
                          name: "pax",
                          id: "outlined-tableCapacity",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {activeTableShape.map((pax, index) => (
                          <MenuItem key={index} value={pax}>
                            {pax}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div className="f10-400 opacity5">Total PAX</div>
                    {formikRoom.errors.pax && formikRoom.touched.pax ? (
                      <div className="pho_14_regular text-danger">
                        {formikRoom.errors.pax}
                      </div>
                    ) : null}
                  </Col>

                  <Col md={6}>
                    <div className="d-flex">
                      <div className="custom">
                        <div className="f10-400 pb-2 opacity5">
                          Temporary Table
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikRoom.values.temporay}
                          onChange={() => onChangeTableTemporary()}
                          className={"mx-1"}
                        />
                      </div>
                      <div className="pl-3 custom">
                        <div className="f10-400 pb-2 opacity5">
                          Active/ Inactive
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikRoom.values.active}
                          onChange={() => onChangeTableActiveInActive()}
                          className={"mx-1"}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="f12-400">Select Table Location</div>
                    <div className="f10-400 opacity5 pb-3">
                      (Locations are based on the seating areas you have
                      selected in seating subscription)
                    </div>
                  </Col>
                  {tableLocation.map((item, index) => (
                    <Col md={4} key={index}>
                      <div className="enCheckWithText w-100">
                        <input
                          type="radio"
                          name="SeatingPreference"
                          checked={
                            formikRoom.values.roomLocation === item.title
                          }
                          onChange={() =>
                            onChangeSelectRoomLocation(item.title)
                          }
                        />
                        <label className="w-100 d-flex align-items-center">
                          <Image
                            src={item.icon}
                            alt={item.title}
                            title={item.title}
                            className="w-25 mr-2"
                          />
                          {item.title}
                        </label>
                      </div>
                    </Col>
                  ))}
                </Row>
                {formikRoom.errors.roomLocation &&
                formikRoom.touched.roomLocation ? (
                  <div className="pho_14_regular text-danger">
                    {formikRoom.errors.roomLocation}
                  </div>
                ) : null}
                <Row className="align-items-center py-3">
                  <Col md={6}>
                    <div className="f12-400">Room Status</div>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100"}>
                      <Select
                        //value={state.tableStatus}
                        value={formikRoom.values.room_status}
                        disabled={!formikRoom.values.active}
                        //onChange={selecthandleChange}
                        onChange={formikRoom.handleChange}
                        inputProps={{
                          name: "room_status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={"Available"}>Available</MenuItem>
                        <MenuItem value={"Unavailable"}>Unavailable</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                {!editRoom ? (
                  <Row className="align-items-center py-3">
                    <Col md={6}>
                      <div className="f12-400">How many Rooms to Create?</div>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col>
                          <NewInputText
                            extraClass={`m-1 w-100 ${
                              formikRoom.errors.area && formikRoom.touched.area
                                ? "enError"
                                : ""
                            }`}
                            inputType="area"
                            onInput={maxLengthCheck}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            maxLength={2}
                            name="area"
                            onChange={formikRoom.handleChange}
                            value={formikRoom.values.area}
                            onFocusOut={formikRoom.handleBlur}
                            // isInvalid={
                            //   formik.errors.bankName && formik.touched.bankName
                            // }
                          />
                          {formikRoom.errors.area && formikRoom.touched.area ? (
                            <div className="pho_14_regular text-danger">
                              {formikRoom.errors.area}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <> </>
                )}
                <div className="d-flex justify-content-center align-items-center py-4">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5"
                    onClick={handleCloseCreateRoom}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    type="button"
                    onClick={() => onCLickAddNewRoom()}
                    className="btn150px btn-lg px-5"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
          <Modal
            show={showCreateBanquet}
            onHide={handleCloseCreateBanquet}
            centered
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div>
                <Modal.Title className="f20-700 pb-2">
                  {editBanquet ? "Edit" : "Create"} a Banquet Area
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 new-subscription-onboarding-component">
              <Form>
                <Row>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-section">
                        Floor Number /Name
                      </InputLabel>
                      <Select
                        value={formikBanquet.values.floor_number}
                        onChange={onChangeSeatNumber}
                        label="Section Number /Name"
                        inputProps={{
                          name: "floor",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {uniqueFloorData.map((item, index) => (
                          <MenuItem key={index} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikBanquet.errors.floor_number &&
                      formikBanquet.touched.floor_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikBanquet.errors.floor_number}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-section">
                        Section Number /Name
                      </InputLabel>
                      <Select
                        value={formikBanquet.values.area}
                        onChange={onChangeSeatArea}
                        label="Section Number /Name"
                        inputProps={{
                          name: "section",
                          id: "outlined-section",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {activeSectionData.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikBanquet.errors.area &&
                      formikBanquet.touched.area ? (
                        <div className="pho_14_regular text-danger">
                          {formikBanquet.errors.area}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <NewInputText
                      labelText="Banquet Name"
                      extraClass={`mb-1 w-100 ${
                        formikBanquet.errors.banquet_name &&
                        formikBanquet.touched.banquet_name
                          ? "enError"
                          : ""
                      }`}
                      inputType="text"
                      name="banquet_name"
                      onChange={formikBanquet.handleChange}
                      value={formikBanquet.values.banquet_name}
                      onFocusOut={formikBanquet.handleBlur}
                      // isInvalid={
                      //   formik.errors.bankName && formik.touched.bankName
                      // }
                    />
                    {formikBanquet.errors.banquet_name &&
                    formikBanquet.touched.banquet_name ? (
                      <div className="pho_14_regular text-danger mb-2">
                        {formikBanquet.errors.banquet_name}
                      </div>
                    ) : (
                      <div className="mb-2"></div>
                    )}
                  </Col>
                  {/* <Col md={6}>
                <NewInputText
                  labelText="Table Capacity"
                  extraClass="mb-3 w-100"
                />
                <span className="f14-400 opacity5 enPositionRightTop">pax</span>
              </Col> */}
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-tableShape">
                        Shape
                      </InputLabel>
                      <Select
                        value={formikBanquet.values.shape}
                        onChange={formikBanquet.handleChange}
                        //onChange={selecthandleChange}
                        //onChange={onChangeTableShape}
                        name
                        label="Table Shape"
                        inputProps={{
                          name: "shape",
                          id: "outlined-tableShape",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={"Rounded Square"}>
                          Rounded Square &#9675;
                        </MenuItem>
                        <MenuItem value={"Circle"}>Circle &#9675;</MenuItem>
                        <MenuItem value={"Rectangle"}>
                          Rectangle &#9645;
                        </MenuItem>
                        <MenuItem value={"Square"}>Square &#9744;</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <NewInputText
                      labelText="Capacity"
                      extraClass={`mb-1 w-100 ${
                        formikBanquet.errors.capacity &&
                        formikBanquet.touched.capacity
                          ? "enError"
                          : ""
                      }`}
                      inputType="number"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onInput={maxLengthCheck}
                      maxLength={5}
                      name="capacity"
                      onChange={formikBanquet.handleChange}
                      value={formikBanquet.values.capacity}
                      onFocusOut={formikBanquet.handleBlur}
                      // isInvalid={
                      //   formik.errors.bankName && formik.touched.bankName
                      // }
                    />
                    {formikBanquet.errors.capacity &&
                    formikBanquet.touched.capacity ? (
                      <div className="pho_14_regular text-danger mb-2">
                        {formikBanquet.errors.capacity}
                      </div>
                    ) : (
                      <div className="mb-2"></div>
                    )}
                  </Col>
                  <Col md={6}>
                    <div className="d-flex">
                      <div className="custom">
                        <div className="f10-400 pb-2 opacity5">
                          Temporary Seat
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikBanquet.values.temporay}
                          onChange={() => onChangeSeatTemporary()}
                          className={"mx-1"}
                        />
                      </div>
                      <div className="pl-3 custom">
                        <div className="f10-400 pb-2 opacity5">
                          Active/ Inactive
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikBanquet.values.active}
                          onChange={() => onChangeSeatActiveInActive()}
                          className={"mx-1"}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="f12-400">Select Banquet Location</div>
                    <div className="f10-400 opacity5 pb-3">
                      (Locations are based on the seating areas you have
                      selected in seating subscription)
                    </div>
                  </Col>
                  {tableLocation.map((item, index) => (
                    <Col md={4} key={index}>
                      <div className="enCheckWithText w-100">
                        <input
                          type="radio"
                          name="SeatingPreference"
                          checked={formikBanquet.values.location === item.title}
                          onChange={() => onChangeSelectSeat(item.title)}
                        />
                        <label className="w-100 d-flex align-items-center">
                          <Image
                            src={item.icon}
                            alt={item.title}
                            title={item.title}
                            className="w-25 mr-2"
                          />
                          {item.title}
                        </label>
                      </div>
                    </Col>
                  ))}
                </Row>
                {formikBanquet.errors.location &&
                formikBanquet.touched.location ? (
                  <div className="pho_14_regular text-danger">
                    {formikBanquet.errors.location}
                  </div>
                ) : null}
                <Row className="align-items-center py-3">
                  <Col md={6}>
                    <div className="f12-400">Banquet Status</div>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100"}>
                      <Select
                        //value={state.tableStatus}
                        value={formikBanquet.values.status}
                        disabled={!formikBanquet.values.active}
                        //onChange={selecthandleChange}
                        onChange={formikBanquet.handleChange}
                        inputProps={{
                          name: "status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value="true">Available</MenuItem>
                        <MenuItem value="false">Unavailable</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>

                <div className="d-flex justify-content-center align-items-center py-4">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5"
                    onClick={handleCloseCreateBanquet}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    type="button"
                    onClick={() => onCLickAddNewSeat()}
                    className="btn150px btn-lg px-5"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
          {/* // add seat in banquet */}
          <Modal show={showCreateSeat} onHide={handleCloseCreateSeat} centered>
            <Modal.Header className="px-4 border-0" closeButton>
              <div>
                <Modal.Title className="f20-700 pb-2">
                  {editRoom ? "Edit" : "Create"} a Seat in Banquet Area
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 new-subscription-onboarding-component">
              <Form>
                <Row>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-section">
                        Floor Number /Name
                      </InputLabel>
                      <Select
                        value={formikRoom.values.floor_number}
                        onChange={onChangeFloorNumber}
                        label="Section Number /Name"
                        inputProps={{
                          name: "floor",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {uniqueFloorData.map((item, index) => (
                          <MenuItem key={index} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikRoom.errors.floor_number &&
                      formikRoom.touched.floor_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikRoom.errors.floor_number}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-room">
                        Room Number /Name
                      </InputLabel>
                      <Select
                        value={formikRoom.values.room_number}
                        onChange={onChangeRoomNumber}
                        label="Room Number /Name"
                        inputProps={{
                          name: "room",
                          id: "outlined-room",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {activeSectionData.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikRoom.errors.room_number &&
                      formikRoom.touched.room_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikRoom.errors.room_number}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <NewInputText
                      labelText="Room Type"
                      extraClass={`mb-1 w-100 ${
                        formikRoom.errors.room_type &&
                        formikRoom.touched.room_type
                          ? "enError"
                          : ""
                      }`}
                      inputType="text"
                      name="room_type"
                      onChange={formikRoom.handleChange}
                      value={formikRoom.values.room_type}
                      onFocusOut={formikRoom.handleBlur}
                      // isInvalid={
                      //   formik.errors.bankName && formik.touched.bankName
                      // }
                    />
                    {formikRoom.errors.room_type &&
                    formikRoom.touched.room_type ? (
                      <div className="pho_14_regular text-danger mb-2">
                        {formikRoom.errors.room_type}
                      </div>
                    ) : (
                      <div className="mb-2"></div>
                    )}
                  </Col>
                  {/* <Col md={6}>
                <NewInputText
                  labelText="Table Capacity"
                  extraClass="mb-3 w-100"
                />
                <span className="f14-400 opacity5 enPositionRightTop">pax</span>
              </Col> */}
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-tableShape">
                        Room Shape
                      </InputLabel>
                      <Select
                        value={formikRoom.values.room_shape}
                        //onChange={selecthandleChange}
                        onChange={onChangeRoomShape}
                        name
                        label="Table Shape"
                        inputProps={{
                          name: "shape",
                          id: "outlined-tableShape",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {/* <MenuItem value={"Circle"}>Circle &#9675;</MenuItem> */}
                        <MenuItem value={"Rectangle"}>
                          Rectangle &#9645;
                        </MenuItem>
                        {/* <MenuItem value={"Square"}>Square &#9744;</MenuItem> */}
                      </Select>
                    </FormControl>
                  </Col>
                  <Col md={6} className="mb-3">
                    <FormControl variant="outlined" className={"w-100 mb-0"}>
                      <InputLabel htmlFor="outlined-tableCapacity">
                        Room Capacity
                      </InputLabel>
                      <Select
                        //value={state.tableCapacity}
                        value={formikRoom.values.pax}
                        //onChange={selecthandleChange}
                        onChange={formikRoom.handleChange}
                        label="Table Capacity"
                        inputProps={{
                          name: "pax",
                          id: "outlined-tableCapacity",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {activeTableShape.map((pax, index) => (
                          <MenuItem key={index} value={pax}>
                            {pax}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div className="f10-400 opacity5">Total PAX</div>
                    {formikRoom.errors.pax && formikRoom.touched.pax ? (
                      <div className="pho_14_regular text-danger">
                        {formikRoom.errors.pax}
                      </div>
                    ) : null}
                  </Col>

                  <Col md={6}>
                    <div className="d-flex">
                      <div className="custom">
                        <div className="f10-400 pb-2 opacity5">
                          Temporary Table
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikRoom.values.temporay}
                          onChange={() => onChangeTableTemporary()}
                          className={"mx-1"}
                        />
                      </div>
                      <div className="pl-3 custom">
                        <div className="f10-400 pb-2 opacity5">
                          Active/ Inactive
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikRoom.values.active}
                          onChange={() => onChangeTableActiveInActive()}
                          className={"mx-1"}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="f12-400">Select Table Location</div>
                    <div className="f10-400 opacity5 pb-3">
                      (Locations are based on the seating areas you have
                      selected in seating subscription)
                    </div>
                  </Col>
                  {tableLocation.map((item, index) => (
                    <Col md={4} key={index}>
                      <div className="enCheckWithText w-100">
                        <input
                          type="radio"
                          name="SeatingPreference"
                          checked={
                            formikRoom.values.roomLocation === item.title
                          }
                          onChange={() =>
                            onChangeSelectRoomLocation(item.title)
                          }
                        />
                        <label className="w-100 d-flex align-items-center">
                          <Image
                            src={item.icon}
                            alt={item.title}
                            title={item.title}
                            className="w-25 mr-2"
                          />
                          {item.title}
                        </label>
                      </div>
                    </Col>
                  ))}
                </Row>
                {formikRoom.errors.roomLocation &&
                formikRoom.touched.roomLocation ? (
                  <div className="pho_14_regular text-danger">
                    {formikRoom.errors.roomLocation}
                  </div>
                ) : null}
                <Row className="align-items-center py-3">
                  <Col md={6}>
                    <div className="f12-400">Room Status</div>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100"}>
                      <Select
                        //value={state.tableStatus}
                        value={formikRoom.values.room_status}
                        disabled={!formikRoom.values.active}
                        //onChange={selecthandleChange}
                        onChange={formikRoom.handleChange}
                        inputProps={{
                          name: "room_status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={"Available"}>Available</MenuItem>
                        <MenuItem value={"Unavailable"}>Unavailable</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                {!editRoom ? (
                  <Row className="align-items-center py-3">
                    <Col md={6}>
                      <div className="f12-400">How many Rooms to Create?</div>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col>
                          <NewInputText
                            extraClass={`m-1 w-100 ${
                              formikRoom.errors.area && formikRoom.touched.area
                                ? "enError"
                                : ""
                            }`}
                            inputType="area"
                            onInput={maxLengthCheck}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            maxLength={2}
                            name="area"
                            onChange={formikRoom.handleChange}
                            value={formikRoom.values.area}
                            onFocusOut={formikRoom.handleBlur}
                            // isInvalid={
                            //   formik.errors.bankName && formik.touched.bankName
                            // }
                          />
                          {formikRoom.errors.area && formikRoom.touched.area ? (
                            <div className="pho_14_regular text-danger">
                              {formikRoom.errors.area}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <> </>
                )}
                <div className="d-flex justify-content-center align-items-center py-4">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5"
                    onClick={handleCloseCreateRoom}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    type="button"
                    onClick={() => onCLickAddNewRoom()}
                    className="btn150px btn-lg px-5"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
          <Modal show={deleteRoom} onHide={handleCloseDeleteRoom} centered>
            <Modal.Header className="py-0 pt-2 border-0" closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body className="f16-500">
              Are you sure to delete this room ?
            </Modal.Body>
            <Modal.Footer className="justify-content-start border-0">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={handleCloseDeleteRoom}
              >
                No
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5"
                onClick={onClickYesDeleteRoom}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={deleteBanquet}
            onHide={handleCloseDeleteBanquet}
            centered
          >
            <Modal.Header className="py-0 pt-2 border-0" closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body className="f16-500">
              Are you sure to delete this banquet ?
            </Modal.Body>
            <Modal.Footer className="justify-content-start border-0">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={handleCloseDeleteBanquet}
              >
                No
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5"
                onClick={onClickYesDeleteBanquet}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

CateringRoomSeatManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  admin_update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  seating_area: state.category && state.category.seating_area,
  allSubscriptionData:
    state.superAdminOnboarding &&
    state.superAdminOnboarding.onboard_subscription_details,
  subscription:
    state.superAdminOnboarding &&
    state.superAdminOnboarding.onboard_subscription_details,
  subscriptionData:
    state.superAdminOnboarding &&
    state.superAdminOnboarding.onboard_subscription_details &&
    state.superAdminOnboarding.onboard_subscription_details
      .casual_dining_status &&
    state.superAdminOnboarding.onboard_subscription_details.casual_dining_status
      .ordering &&
    state.superAdminOnboarding.onboard_subscription_details.casual_dining_status
      .ordering.home_delivery,
});

export default connect(mapStateToProps, {
  admin_update_new_subscription_for_vendor,
})(withRouter(CateringRoomSeatManagement));
